import type { InvoicingSettingsPreviewPatch } from '../../../types/invoicingSettingsPreviewPatch'
import type { PaymentMethod } from '../../../types/paymentMethod'
import { paymentMethodsFields } from '../constants/paymentMethodsFields'
import type { PaymentMethodsSettings } from '../types/paymentMethods/paymentMethodsSettings'
import { getPaymentMethodsPayload } from './getPaymentMethodsPayload'

interface GetPaymentsAndRemindersPreviewPatchOptions {
  savedPaymentMethods: PaymentMethod[]
  savedValues: PaymentMethodsSettings
  values: PaymentMethodsSettings
}

// Reminders are not on the invoice, so only payment methods reach the preview.
export const getPaymentsAndRemindersPreviewPatch = (
  options: GetPaymentsAndRemindersPreviewPatchOptions,
): InvoicingSettingsPreviewPatch | undefined => {
  const { savedPaymentMethods, savedValues, values } = options
  const hasPaymentMethodsChanged = paymentMethodsFields.some(
    (field) => (values[field] || '') !== (savedValues[field] || ''),
  )

  if (!hasPaymentMethodsChanged) {
    return undefined
  }

  return {
    settings: {
      values: {
        paymentMethods: getPaymentMethodsPayload(savedPaymentMethods, values),
      },
    },
  }
}
